import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { Container, TextField, Select, Box, Button, Typography, FormControl } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { t } from 'i18next';
import { Controller, useForm } from 'react-hook-form';
import currencies from '../../data/currencies';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Loading from '../Loading';
import { useDropzone } from "react-dropzone";
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { useCurriculums } from '../../hooks/useCurriculums';
import { useClasses } from '../../hooks/useClasses';

function EditResource() {
    const { id } = useParams()
    const [levels, setLevels] = useState([]);
    const [error, setError] = useState(null);
    const lang = Cookies.get("i18next") || "en";
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();
    
    const [resource, setResource] = useState()
    const [loading, setLoading] = useState(false);
    const { teacher } = useSelector((state) => state.teacher);
    const i18next = Cookies.get('i18next');
    const [subjects, setSubjects] = useState([])
        const { data: Curriculums } = useCurriculums()
        const { data: Classes } = useClasses()
        const Classrooms = [
            { id: "First semester", label: t("First semester") },
            { id: "Second semester", label: t("First semester") }
        ]
        const [fileImageName, setFileImageName] = useState('');
        const [Image, setImage] = useState();
          const [fileName, setFileName] = useState('');
          const [file, setFile] = useState(null);
    function convertDate(dateString) {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // yyyy-mm-dd
    }
    const { register, handleSubmit, formState: { errors }, control, reset } = useForm({
        defaultValues: {
            level: '',
            subject: '',
            resource: '',
            semester: '',
            classId:"",
            curriculums: '',
            price: '',
            currency: '',
            startDate: '',
            endDate: '',
            image:'',
            duration:'',
            linkResource: ""

        }
    });
    const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } = useDropzone({
        onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),  // عند اختيار الصورة
        accept: 'image/*'  // تحديد أن نوع الملف المسموح به هو الصور
    });
          const { getRootProps: getRootPropsFile, getInputProps: getInputPropsFile } = useDropzone({
            onDrop: (acceptedFiles) => handleFile(acceptedFiles),  // عند اختيار المستند
            accept: '.pdf,.doc,.docx,.ppt,.pptx,.txt'  // تحديد أن نوع الملف المسموح به هو المستندات
          });
    // هذه دالة التعامل مع صورة
    const handleFileUpload = (files) => {
        if (files && files[0]) {
            setFileImageName(files[0].name);  // تخزين اسم الصورة
            setImage(files[0]);

        }
    };
          // هذه دالة التعامل مع المستند
  const handleFile = (files) => {
    if (files && files[0]) {
      setFileName(files[0].name);  // تخزين اسم المستند
      setFile(files[0]);

    }
  };
    useEffect(() => {
        const fetchLevels = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/admin/levels`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setLevels(data.data);
            } catch (err) {
                console.error("Error fetching levels:", err);
                setError(err.message);
            }
        };
        const getSubjects = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_KEY}api/v1/subject/allSubjects`);
            setSubjects(response.data.data);
        };
        const fetchResourceData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/resources/${id}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setResource(data.data); // Assuming the package contains a level property
                setLoading(true)
            } catch (err) {
                setError(err.message);
            }
        };

        // Fetch data
        fetchLevels();
        getSubjects();
        fetchResourceData();

    }, [id]);

    useEffect(() => {
        if (resource) {
            reset({
                level: resource.level.id,
                subject: resource?.subject.id,
                resource: resource.resource,
                classId: resource?.classId.id,
                semester: resource.semester,
                curriculums: resource?.curriculums.id,
                price: resource.price,
                currency: resource.currency,
                startDate: convertDate(resource.startDate),
                endDate: convertDate(resource.endDate),
                image:resource.image,
                duration:resource.duration,
                linkResource:resource.linkResource
            });
            setFileImageName(resource.image)
            setFileName(resource.docs)

        }
    }, [resource, reset]);

    const navigate = useNavigate();

    async function onSubmit(data) {
        closeSnackbar();
         const startDateTime = new Date(data.startDate); // تحويل إلى كائن تاريخ
            const endDateTime = new Date(data.endDate); // تحويل إلى كائن تاريخ
            const differenceInMilliseconds = endDateTime - startDateTime;
            const differenceInSeconds = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
            // تحقق من أن startDate أقل من endDate
            if (startDateTime >= endDateTime) {
              enqueueSnackbar(t("Start date must be earlier than end date"), { variant: "error", autoHideDuration: 5000 });
              return; // إنهاء الوظيفة إذا كان الشرط غير محقق
            }
            data.duration=differenceInSeconds
            data.startDate = startDateTime;
            data.endDate = endDateTime;
            const tmpData = { ...data, teacherId: teacher.id };
            const formData = new FormData();
            if(Image)
            formData.append("image", Image);
            if(file)
                formData.append("docs", file);
            for (const key in tmpData) {
              formData.append(key, tmpData[key]);
            }
        try {
            await axios.put(`${process.env.REACT_APP_API_KEY}api/v1/resources/edit-resource/${id}`, formData);
            setLoading(true);
            enqueueSnackbar(t("resourseEditMsg"), { variant: "success", autoHideDuration: "5000" });
            navigate("/teacher/resources")
        } catch (err) {
            enqueueSnackbar(t("resourseEditErrMsg"), { variant: "error", autoHideDuration: "5000" });
            setLoading(false);
            throw new Error("Something went wrong's " + err);
        }
    }


    return (
        <Navbar>
            {loading ? <>
                <Container sx={{ marginTop: '120px', marginBottom: '80px' }}>
                    <h1 className="text-3xl text-center my-4">{t("Edit Resource")}</h1>
                    <form style={{ margin: 'auto' }} encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("subject")}
                            </InputLabel>
                            <Controller
                                name="subject"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        fullWidth
                                        {...register("subject", {
                                            required: t("isRequired"),
                                        })}
                                    >
                                        {i18next === "ar"
                                            ? subjects.map((subject, index) => (
                                                <MenuItem key={index} value={subject.id}>{t(subject.titleAR)}</MenuItem>
                                            ))
                                            : subjects.map((subject, index) => (
                                                <MenuItem key={index} value={subject.id}>{t(subject.titleEN)}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                )}
                                rules={{ required: t("required") }}
                            />
                        </Box>
                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("level")}
                            </InputLabel>
                            <Controller
                                name="level"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        fullWidth
                                        {...register("level", {
                                            required: t("isRequired"),
                                        })}
                                    >
                                        {i18next === "ar"
                                            ? levels.map((level, index) => (
                                                <MenuItem key={index} value={level.id}>{t(level.titleAR)}</MenuItem>
                                            ))
                                            : levels.map((level, index) => (
                                                <MenuItem key={index} value={level.id}>{t(level.titleEN)}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                )}
                                rules={{ required: t("required") }}
                            />
                        </Box>

                        <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("classes")}
                        </InputLabel>
                        <Controller
                            name="classId"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("classId", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {
                                        Classes?.data.map((calss, index) => (
                                            <MenuItem key={index} value={calss.id}>{i18next === "ar" ? calss.titleAR : calss.titleEN}</MenuItem>
                                        ))
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("studyCurriculum")}
                        </InputLabel>
                        <Controller
                            name="curriculums"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("curriculums", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {
                                        Curriculums?.data.map((Curriculum, index) => (
                                            <MenuItem key={index} value={Curriculum.id}>{i18next === "ar" ? Curriculum.titleAR : Curriculum.titleEN}</MenuItem>
                                        ))
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("semester")}
                        </InputLabel>
                        <Controller
                            name="semester"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("semester", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {Classrooms?.length > 0 ? (
                                        Classrooms.map((curriculums, index) => (
                                            <MenuItem key={index} value={curriculums.id}>
                                                {t(curriculums.id)}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem disabled>{t("noData")}</MenuItem>
                                    )}
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>

                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("resource")}
                            </InputLabel>
                            <Controller
                                name="resource"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        fullWidth
                                        {...register("resource", {
                                            required: t("isRequired"),
                                        })}
                                    >
                                        <MenuItem value="Lecture">{t("Lecture")}</MenuItem>
                                        <MenuItem value="Exam">{t("Exam")}</MenuItem>
                                        <MenuItem value="Reviews">{t("Reviews")}</MenuItem>
                                        <MenuItem value="Summary of the material">{t("Summary of the material")}</MenuItem>
                                    </Select>
                                )}
                                rules={{ required: t("required") }}
                            />
                        </Box>
                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("startDate")}
                            </InputLabel>
                            <Controller
                                name="startDate"
                                control={control}
                                render={({ field }) => <TextField type='date' {...field} fullWidth />}
                                rules={{ required: t("required") }}
                            />
                        </Box>
                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("End Date")}
                            </InputLabel>
                            <Controller
                                name="endDate"
                                control={control}
                                render={({ field }) => <TextField type='date' {...field} fullWidth />}
                                rules={{ required: t("required") }}
                            />
                        </Box>

                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("price")}
                            </InputLabel>
                            <Controller
                                name="price"
                                control={control}
                                render={({ field }) => <TextField  {...field} fullWidth />}
                                rules={{ required: t("required") }}
                            />
                        </Box>
                        <Box sx={{ marginBottom: "18px" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                                {t("currency")}
                            </InputLabel>
                            <Controller
                                name="currency"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        fullWidth
                                        {...register("currency", {
                                            required: t("isRequired"),
                                        })}
                                    >
                                        {
                                            currencies.map((curr,index) => {
                                                return <MenuItem key={index} value={curr.title}>{lang === "en" ? curr.titleEn : curr.titleAr}</MenuItem>
                                            })
                                        }
                                    </Select>
                                )}
                                rules={{ required: t("required") }}
                            />
                        </Box>
                        <Box sx={{ marginBottom: "18px" }}>
            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
              {t("Resource link (if you do not include documents related to the Resource, you must include a link to the Resource)")}
            </InputLabel>

            <FormControl fullWidth margin='dense'>
              <TextField type="text"  {...register("linkResource", {
                required: {
                  // value: !file,
                  message: t("file_video-validation")
                },
                pattern: {
                  value: /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/,
                  message: t("youtube_link")
                }
              })} />

              <p className='text-red-500'>{errors.linkResource?.message}</p>
            </FormControl>
          </Box>
          <Box sx={{  maxWidth: "100%" }}>
            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Resource documents")}
              </InputLabel>
              <div {...getRootPropsFile()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsFile()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Resource documents")}
                </Typography>
              </div>

              {/* عرض اسم المستند بعد اختياره */}
              {fileName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("Selected File")}: {fileName}
                </Typography>
              )}
            </Box>

            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Choose a suitable image for the resource")}
              </InputLabel>
              <div {...getRootPropsImage()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsImage()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Choose a suitable image for the resource")}
                </Typography>
              </div>

              {/* عرض اسم الصورة بعد اختياره */}
              {fileImageName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("selected Image")}: {fileImageName}
                </Typography>
              )}
            </Box>
          </Box>
                        <br />
                        <br />
                        <Button
                             type="submit"
                            variant="contained"
                        >{t("Edit Package")}
                        </Button>
                    </form>
                </Container>
            </> : <>
                <Loading />
            </>}

        </Navbar>
    )
}

export default EditResource;
